module.exports = __webpack_public_path__ + "img/5.47718b8f.png";